import { useMemo } from 'react';

export const useBaseline = ({ baseline }) => {
  const baselineTotal = useMemo(() => {
    if (!baseline) return;
    return Object.keys(baseline).reduce((p, key) => p + baseline[key].current, 0);
  }, [baseline]);

  const baselineRevenueTotal = useMemo(() => {
    if (!baseline) return;
    return Object.keys(baseline).reduce((p, key) => p + baseline[key].currentRevenue, 0);
  }, [baseline]);

  const activeFeatures = useMemo(() => {
    if (!baseline) return;
    return Object.keys(baseline).filter(key => baseline[key].current > 0);
  }, [baseline]);

  const inactiveFeatures = useMemo(() => {
    if (!baseline) return;
    return Object.keys(baseline).filter(key => baseline[key].current === 0);
  }, [baseline]);

  return {
    baselineTotal,
    baselineRevenueTotal,
    activeFeatures,
    inactiveFeatures,
  };
};
